/**
 * @generated SignedSource<<2373b1346ca19ed961ae9c12362d0db7>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type AssignStakeholderCategoryInputObject = {
  categoryId: string;
  stakeholderId: string;
};
export type categoryCell_AssignStakeholderCategoryMutation$variables = {
  input: AssignStakeholderCategoryInputObject;
};
export type categoryCell_AssignStakeholderCategoryMutation$data = {
  readonly assignStakeholderCategory: {
    readonly errors: ReadonlyArray<{
      readonly message: string;
    }>;
    readonly stakeholder: {
      readonly id: string;
    } | null | undefined;
  } | null | undefined;
};
export type categoryCell_AssignStakeholderCategoryMutation = {
  response: categoryCell_AssignStakeholderCategoryMutation$data;
  variables: categoryCell_AssignStakeholderCategoryMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "concreteType": "Stakeholder",
  "kind": "LinkedField",
  "name": "stakeholder",
  "plural": false,
  "selections": [
    (v2/*: any*/)
  ],
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "message",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "categoryCell_AssignStakeholderCategoryMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "AssignStakeholderCategoryMutationPayload",
        "kind": "LinkedField",
        "name": "assignStakeholderCategory",
        "plural": false,
        "selections": [
          (v3/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "UserError",
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              (v4/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "categoryCell_AssignStakeholderCategoryMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "AssignStakeholderCategoryMutationPayload",
        "kind": "LinkedField",
        "name": "assignStakeholderCategory",
        "plural": false,
        "selections": [
          (v3/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "UserError",
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              (v4/*: any*/),
              (v2/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "91b4e5bd8e0437abfc45c9323328a347",
    "id": null,
    "metadata": {},
    "name": "categoryCell_AssignStakeholderCategoryMutation",
    "operationKind": "mutation",
    "text": "mutation categoryCell_AssignStakeholderCategoryMutation(\n  $input: AssignStakeholderCategoryInputObject!\n) {\n  assignStakeholderCategory(input: $input) {\n    stakeholder {\n      id\n    }\n    errors {\n      message\n      id\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "7f7ef1a0d809a51ab7f98df86b3cd176";

export default node;
